import React from "react";

import { translation } from "@/i18n";
import { nsDialog } from "@/i18n/locales/dialog";
import { useDialogStyles, useWarningButtonStyles } from "@/styles";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import { DialogConfirmParam } from "../hooks";
import styles from "../index.module.css";

const useTranslation = translation.use(nsDialog);

export const DialogConfirm: React.FC<DialogConfirmParam> = ({
  title,
  displayMessage,
  buttonText,
  cancelButtonText,
  onClick,
  onClickCancel,
  dialogPhase,
  setDialogPhase,
  element,
  isThemeRed,
  isDisableButton = false,
  isDisableCancelButton = false,
  maxWidth,
  inProgressButtonText,
}) => {
  const { t } = useTranslation();
  const buttonClasses = useWarningButtonStyles();
  const dialogClasses = useDialogStyles();
  const isInProgress = dialogPhase === "in_progress";
  return (
    <Dialog
      onOpenChange={() => {
        // Prevent dismissing the dialog while progress is active
        if (inProgressButtonText && isInProgress) {
          return;
        }
        setDialogPhase(null);
      }}
      open={
        dialogPhase === "confirm" || (!!inProgressButtonText && isInProgress)
      }
    >
      <DialogSurface
        className={dialogClasses.dialog}
        style={maxWidth ? { maxWidth } : undefined}
      >
        <DialogBody>
          <DialogTitle>{title}</DialogTitle>
          <DialogContent>
            <div className={styles.dialogMessageContent}>{displayMessage}</div>
            {element}
          </DialogContent>
          <DialogActions>
            <Button
              appearance={isThemeRed ? "secondary" : "primary"}
              onClick={() => {
                onClick();
              }}
              disabled={isDisableButton || isInProgress}
              className={isThemeRed ? buttonClasses.warning : ""}
            >
              {isInProgress && inProgressButtonText
                ? inProgressButtonText
                : buttonText}
            </Button>
            <Button
              onClick={() => {
                onClickCancel && onClickCancel();
                setDialogPhase(null);
              }}
              disabled={isDisableCancelButton || isInProgress}
            >
              {cancelButtonText ?? t.dialog.common.cancelButton()}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
